import React from 'react';
import { ISVGType } from './SVGType';

export const LeftArrow = (props: ISVGType) => {
  const { stroke } = props;
  return (
    <svg width="13" height="14" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21L2 11L12 1" stroke={stroke} strokeWidth="3" />
    </svg>
  )
}

export const RightArrow = (props: ISVGType) => {
  const { stroke } = props;
  return (
    <svg width="12" height="14" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 21L11 11L1 1" stroke={stroke} strokeWidth="3" />
    </svg>
  )
}
